import axios from 'axios'

export default function({ $axios, app, route }, inject) {
  // override @nuxtjs/axios axios version
  const axiosInstance = axios.create({
    baseURL: process.env.API_BASE_URL,
    proxyHeaders: false,
    credentials: true,

    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken'
  })
  inject('axios', axiosInstance)

  // set no-cache to prevent IE caching the request
  //   $axios.setHeader('Pragma', 'no-cache')

  $axios.onRequest((config) => {
    console.log('Making request to ' + config.url)
  })

  $axios.onError(async (error) => {
    const code = parseInt(error.response && error.response.status)
    console.log('Got axios errror, route is ' + route.name)
    if (error.request.responseURL.endsWith('/profile/me/')) {
      console.log('Currently in no subscription page, wont intercept')
      return
    }
    if (code === 401 || code === 403) {
      console.log('Intercepted 401 or 403')
      await app.$oneplaceHelper.goLogin()
    }
  })
}
